import React, { useCallback, useContext, useEffect, useState } from "react";
import { CardList } from "../components/CardList";
import Input from "../components/Input";
import { Loader } from "../components/Loader";
import { AuthContext } from "../context/AuthContext";
import { CardContext } from "../context/CardContext";
import { useHttp } from "../hooks/http.hook";
import { useHistory } from 'react-router-dom';

export const SearchPage = () => {
  const card = useContext(CardContext);
  const [cards, setCards] = useState([]);
  const [filters, setFilters] = useState("");
  const { loading, request } = useHttp();
  const { token } = useContext(AuthContext);

  const history = useHistory()

  useEffect(() => {
    window.M.updateTextFields();
  }, [])
  useEffect(()=> {
    // console.log(cards);
  }, [cards])
  const DeleteCard = async (form) => {
    try {
      const data = await request(
        "/api/card/delete",
        "POST",
        { _id: form._id },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      // alert(data.message)
      SearchCards();
    } catch (e) {}
  };

  const SaveCard = async (form) => {
    try {
      delete form._id;
      const data = await request(
        "/api/card/generate",
        "POST",
        { form: { ...form, formed: false, formedId: null, _id: null } },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      alert(data.message);
      // console.log(data);
    card.createForm({...form, formedId: data.formedId, _id: data.cardId});
    history.push("/edit");
    } catch (e) {}
  };

  const CardEdit = (form) => {
    card.createForm(form);
  };

  const fetchCards = useCallback(async () => {
      if (filters !== ''){
    try {
      const fetched = await request(
        "/api/card/search",
        "POST",
        { filters },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      let cards = fetched?.reverse()
      setCards(cards)
      // console.log('fetch', fetched);
      // setCards(fetched)
    } catch (e) {}
    }
  }, [token, request]);

  const SearchCards = async () => {
    try {
      const fetched = await request(
        "/api/card/search",
        "POST",
        { filters },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      let cards = fetched?.reverse()
      setCards(cards)
      // setCards(fetched);
    } catch (e) {}
  };
  const BigSearchCards = async () => {
    try {
      const fetched = await request(
          "/api/card/bigsearch",
          "POST",
          { filters },
          {
            Authorization: `Bearer ${token}`,
          }
      );
      let cards = fetched?.reverse()
      setCards(cards)
      // setCards(fetched);
    } catch (e) {}
  };

  const SearchRegularCards = async () => {
    try {
      console.log(123)
      const fetched = await request(
          "/api/card/regular",
          "GET",
          null,
          {
            Authorization: `Bearer ${token}`,
          }
      );
      let cards = fetched?.reverse()
      setCards(cards)
      // setCards(fetched);
    } catch (e) {}
  };

  useEffect(() => {
    fetchCards();
    window.M.updateTextFields();
  }, [fetchCards]);

  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="row">
        <div className="input-field col s8">
          <input
            value={filters}
            onChange={(e) => setFilters(e.target.value)}
            placeholder={"Поиск по базе"}
            id={"search"}
            type={"search"}
          />
        </div>
        <div style={{ paddingTop: "2%" }} className="col s1">
          <a
            className="waves-effect waves-light btn-small"
            onClick={SearchCards}
          >
            Найти
          </a>
        </div>
        <div style={{ paddingTop: "2%" }} className="col s3">
          <a
              className="waves-effect waves-light btn-small"
              onClick={BigSearchCards}
          >
            Расширенный поиск
          </a>
        </div>
      </div>
      <div className="row">
        <div style={{ paddingTop: "0%" }} className="col s3">
          <a
              className="waves-effect waves-light btn-small"
              onClick={SearchRegularCards}
          >
            Показать постоянных клиентов
          </a>
        </div>
      </div>
      {!loading && (
        <CardList
          SaveCard={SaveCard}
          DeleteCard={DeleteCard}
          CardEdit={CardEdit}
          cards={cards}
        />
      )}
    </div>
  );
};
